import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../Cookie/Cookie.scss";

const Cookie = ({ manageAnimation, handleAnimation }) => {
    const { t } = useTranslation();
    const manageCookieHandler = () => {
        localStorage.setItem("cookie", false);
        handleAnimation(true);
    };

    return (
        <div>
            <div
                className={`${
                    manageAnimation ? "cookie-animation" : "cookie-notification"
                }`}
            >
                <div className="cookie-wrapper">
                    <div className="cookie-holder">
                        <i className="icon icon-cookie"></i>
                    </div>
                    <p>
                        {t("cookieStmt")}{" "}
                        <Link to="/privacy">{t("Privacy Policy")}</Link> and{" "}
                        <Link to="/Cookies">Cookie Policy.</Link>
                    </p>

                    <button
                        onClick={manageCookieHandler}
                        className="accept-btn"
                    >
                        {t("acceptContinue")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Cookie;
